// frontend/src/utils/dueDates.js

export const getDaysRemaining = (iso) => {
  if (!iso) return null;

  const due = new Date(iso);
  const now = new Date();

  // Clear time for accurate day difference
  due.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  const diffTime = due - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let text = "";
  let color = "";

  if (diffDays > 2) {
    text = `${diffDays} days remaining`;
    color = "green";
  } else if (diffDays > 0) {
    text = `${diffDays} day${diffDays === 1 ? "" : "s"} remaining`;
    color = "orange";
  } else if (diffDays === 0) {
    text = "Due today";
    color = "orange";
  } else {
    text = `Overdue by ${Math.abs(diffDays)} day${Math.abs(diffDays) === 1 ? "" : "s"}`;
    color = "red";
  }

  return { text, color };
};
